import { useEffect, useState } from "react";

export const CLoader = ({ condition }) => {
	const containerStyle = {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		gap: ".3rem",

		width: "100vw",
		height: "100vh",
	};

	const [loaderProgress, setLoaderProgress] = useState(0);

	useEffect(() => {
		let count = 0;

		let interv = setInterval(() => {
			if (count < 100) {
				setLoaderProgress(count++);
			} else {
				clearInterval(interv);
				return;
			}
		}, 10);

		return () => clearInterval(interv);
	}, []);

	return (
		<div
			className={`custom-loader ${
				condition && loaderProgress == 99 ? "hide-load" : ""
			}`}
			style={containerStyle}
		>
			<span>TheCopyDev</span>
			<svg viewBox="0 0 100 100" width="80">
				<line
					x1={10}
					x2={90}
					y1={50}
					y2={50}
					stroke="black"
					strokeWidth={1}
					strokeDasharray={"10"}
				></line>
			</svg>
			<span>{loaderProgress}%</span>
		</div>
	);
};
